<template>
  <!-- <b-form-group> -->
  <span v-if="uploading_progress === false">
    <b-button v-bind="$attrs" v-on="$listeners" :disabled="is_disabled">
      <b-spinner small v-if="loading" class="mr-1"></b-spinner>
      <span :hidden="!(!only_loading || (only_loading && !loading))"><slot /></span>
    </b-button>
  </span>
  <span v-else>
    <b-button class='p-0' v-bind="$attrs" v-on="$listeners" :disabled="is_disabled">
      <div :class="{'button-padding': true, 'button-padding-no-bottom': uploading_progress !== null && uploading_progress !== 100}">
        <b-spinner small v-if="loading" class="mr-1"></b-spinner>
        <span v-if="post_upload && uploading_progress === 100 && loading">{{post_upload}}</span>
        <span v-else><slot /></span>
      </div>
      <b-progress v-if="uploading_progress !== null && uploading_progress !== 100" :value="uploading_progress" variant="primary" height="3px"></b-progress>
    </b-button>
  </span>

  <!-- </b-form-group> -->
</template>

<script>

export default {
  name: 'LoadingButton',
  props: {
    disabled: {
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    },
    uploading_progress: {
      required: false,
      default: false
    },
    post_upload: {
      required: false,
    },
    only_loading: {
      required: false,
      default: false
    }
  },
  computed: {
    is_disabled() {
      if (this.disabled !== undefined) {
        return this.disabled || this.loading
      } else {
        return this.loading
      }
    }
  }
}
</script>

<style>

.loading-spinner-1 {
  width: 1.2em !important;
  height: 1.2em  !important;
}

.button-padding {
  padding: 0.375rem 0.75rem;
}

.button-padding-no-bottom {
  padding-bottom: 0.1875rem;
  padding-top: 0.1875rem;
}

</style>
